import { render } from "./CenteredContainer.vue?vue&type=template&id=271cda2e"
import script from "./CenteredContainer.vue?vue&type=script&lang=js"
export * from "./CenteredContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__